'use-client';
import * as React from 'react';
import type { FreestyleProps } from '../Freestyle.types';
import TPAGallery from '../../TPAGallery/viewer/TPAGallery';

const Freestyle: React.FC<FreestyleProps> = props => {
  return <TPAGallery {...props}></TPAGallery>;
};

export default Freestyle;
